
import React from "react";
import { Link } from "react-router-dom";

function Pricing() {
  return (
    <div className="bg-[linear-gradient(135deg,#05001a,#0a0133,#140145)]">


      <div
        className="
        relative px-5 py-20 text-center text-white font-sans
        bg-[linear-gradient(135deg,#05001a,#0a0133,#140145)]
        [clip-path:polygon(0_5%,100%_0,100%_100%,0_95%)]
        
      "
      >
        {/* Header */}
        <div className="max-w-3xl mx-auto mb-10">
          <h1 className="text-[28px] md:text-[38px] font-bold leading-tight mb-2">
            TRANSPARENT PRICING <br />
            FOR ALL IT SERVICES
          </h1>
          <p className="text-sm md:text-base text-[#e0e0e0] max-w-xl mx-auto leading-relaxed">
            Choose a plan that fits your business — No hidden charges.
            <br />
            Pay only for what you need, Scale anytime.
          </p>
        </div>

        {/* Cards */}
        <div className="flex justify-center gap-6 flex-wrap">
          {/* BASIC */}
          <div
            className="
            bg-white/5 backdrop-blur-sm px-8 py-10 w-[300px] rounded-2xl text-left
            transition duration-300
            border-2 border-[#007bff] shadow-[0_0_12px_#007bff]
            hover:-translate-y-2 hover:shadow-[0_10px_40px_rgba(0,0,0,0.4)]
          "
          >
            <h2 className="text-[20px] tracking-wide mb-2 text-center">BASIC</h2>
            <h3 className="text-[32px] font-bold mb-5 text-center">
              ₹4,999 <span className="text-[16px] text-[#cccccc]">/ month</span>
            </h3>
            <ul className="list-disc pl-5 mb-4 space-y-2 text-[15px] leading-relaxed">
              <li>
                Starting a plan <br />
                that fits your
                <br />
                business
              </li>
              <li>Hey-rien charges</li>
            </ul>
          </div>

          {/* STANDARD */}
          <div
            className="
            bg-white/5 backdrop-blur-sm px-8 py-10 w-[300px] rounded-2xl text-left
            transition duration-300
            border-2 border-[#a400ff] shadow-[0_0_12px_#a400ff]
            hover:-translate-y-2 hover:shadow-[0_10px_40px_rgba(0,0,0,0.4)]
          "
          >
            <h2 className="text-[20px] tracking-wide mb-2 text-center">
              STANDARD
            </h2>
            <h3 className="text-[32px] font-bold mb-5 text-center">
              ₹12,999 <span className="text-[16px] text-[#cccccc]">/ month</span>
            </h3>
            <ul className="list-disc pl-5 mb-4 space-y-2 text-[15px] leading-relaxed">
              <li>Full Stack Web</li>
              <li>App Development</li>
              <li>Civen Security set</li>
              <li>Email integration</li>
              <li>24/7 Support</li>
            </ul>
          </div>

          {/* PREMIUM */}
          <div
            className="
            bg-white/5 backdrop-blur-sm px-8 py-10 w-[300px] rounded-2xl text-left
            transition duration-300
            border-2 border-[#ff00c8] shadow-[0_0_12px_#ff00c8]
            hover:-translate-y-2 hover:shadow-[0_10px_40px_rgba(0,0,0,0.4)]
          "
          >
            <h2 className="text-[20px] tracking-wide mb-2 text-center">
              PREMIUM
            </h2>
            <h3 className="text-[32px] font-bold mb-5 text-center">
              ₹39,999 <span className="text-[16px] text-[#cccccc]">/ month</span>
            </h3>
            <ul className="list-disc pl-5 mb-4 space-y-2 text-[15px] leading-relaxed">
              <li>
                Cusiom Enterprise
                <br />
                Solutions
              </li>
              <li>
                Dedicated Cloud <br />
                &amp; DevOps
              </li>
              <li>AI/ML Support</li>
            </ul>
          </div>
        </div>

        {/* Buttons */}
        <div className="mt-10 flex justify-center gap-8 flex-wrap">
        <Link to="/contact">
          <button
            className="
            bg-gradient-to-r from-blue-500 to-violet-500
            text-white font-semibold text-[16px]
            px-6 py-2 rounded-lg uppercase tracking-wide
            hover:opacity-90 transition
          "
          >
            GET STARTED
          </button>
          </Link>


          <Link to="/contact">
          <button
            className="
            border-2 border-[#ff4fd8] text-white font-semibold text-[16px]
            px-6 py-2 rounded-lg uppercase tracking-wide
            bg-transparent
            hover:bg-[#ff4fd8]/10 transition
          "
          >
            REQUEST CUSTOM QUOTE
          </button></Link>
        </div>

        {/* Company name */}
        <h3 className="mt-12 text-[18px] tracking-[0.2em] font-semibold">
          Cybredge PRIVATE LIMITED
        </h3>
      </div>
    </div>
  );
}

export default Pricing;
